import React, { useState } from "react";
import { useApiUrl, useTranslate } from "@refinedev/core";
import { Form, Input, Modal, notification } from "antd";
import { axiosInstance } from "../../../authProvider";

type InviteUserModalProps = {
  open: boolean;
  accountId: number | undefined | null;
  accountName?: string;
  onCancel: () => void;
  onSuccess: () => void;
};

export const InviteUserModal: React.FC<InviteUserModalProps> = ({
  open,
  accountId,
  onCancel,
  onSuccess,
}) => {
  const _t = useTranslate();
  const apiUrl = useApiUrl();
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInvite = async (values: { email: string }) => {
    if (!accountId) {
      return;
    }
    setIsSubmitting(true);
    try {
      await axiosInstance.post(`${apiUrl}/accounts/${accountId}/invite-user`, {
        email: values.email,
      });
      notification.success({
        message: _t("users.messages.inviteSuccess"),
      });
      form.resetFields();
      onCancel();
      onSuccess();
    } catch (error: any) {
      const errors = error?.response?.data?.errors;
      if (errors && "email" in errors && errors.email === "emailAlreadyExists") {
        form.setFields([
          {
            name: "email",
            errors: [_t("users.errors.emailAlreadyExists")],
          },
        ]);
      } else {
        notification.error({
          message: _t("users.messages.inviteError"),
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      title={_t("users.titles.invite")}
      open={open}
      onCancel={onCancel}
      onOk={() => form.submit()}
      afterOpenChange={(visible) => {
        if (visible) {
          form.resetFields();
        }
      }}
      confirmLoading={isSubmitting}
      destroyOnClose
      okText={_t("users.titles.invite")}
    >
      <Form form={form} layout="vertical" onFinish={handleInvite} className="!mt-4">
        <Form.Item
          label={_t("users.fields.email")}
          name="email"
          rules={[
            { required: true, message: _t("fields.errors.required") },
            { type: "email", message: _t("pages.register.errors.invalidEmail") },
          ]}
        >
          <Input autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  );
};
